import type { InviteDto } from "@ied/shared-types";
import { useMutation } from "@tanstack/react-query";
import { SERVICE_API } from "@/lib/consts";

type CreateInviteBody = Pick<InviteDto, "groups" | "type">;

export function useCreateInvite() {
	return useMutation({
		mutationKey: ["invites"],
		mutationFn: async (data: CreateInviteBody) => {
			const res = await fetch(`${SERVICE_API}/api/invites`, {
				method: "POST",
				credentials: "include",
				body: JSON.stringify(data),
				headers: {
					"Content-Type": "application/json",
				},
			});
			if (!res.ok) {
				throw new Error("Unable to create invite");
			}

			return (await res.json()) as InviteDto;
		},
		onSuccess: (_, __, ___, c) => {
			c.client.invalidateQueries({
				queryKey: ["invites"],
			});
		},
	});
}
